import Container from "@mui/material/Container";
import Grid from '@mui/material/Unstable_Grid2';
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Divider from "@mui/material/Divider";

import { useState, useEffect } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { userDetailStyle } from '../../styles/pages/user/user-detail';
import { useQueryUserDetail } from '../../api/user';
import { UserDetailById } from '../../types/user';
import { selectAuthUser } from '../../store/auth/selector';

export function Profile(){
  const { id } = useParams();
  const navigate = useNavigate();
  const profile = useSelector(selectAuthUser);

  const [userDetail, setUserDetail] = useState<UserDetailById | null>(null);
  
  const getUserDetail = useQueryUserDetail({
    query: {
      userId: profile.userId,
    },
    options: {
      onSuccess: (res) => {
        setUserDetail(res.data);
      },
      onError: () => {
        setUserDetail(null);
      }
    },
  });

  return(
    <Container maxWidth={false} sx={userDetailStyle.contentContainer}>
      <Grid container spacing={2}>
        <Grid xs={12}>
          <Typography variant="h3" sx={userDetailStyle.contentTypography}>Profile</Typography>
        </Grid>
        <Grid xs={12}>
          <Paper elevation={3} sx={userDetailStyle.contentContainerGridItem2Paper}>
            <Grid container spacing={2}>
              <Grid xs={3}>
                <Typography variant="subtitle1" sx={userDetailStyle.contentTypography}>Personal Information</Typography>
              </Grid>
              <Grid container spacing={2} xs>
                <Grid xs={12}>
                  <Box
                    component="img"
                    src={userDetail?.avatar}
                    alt="user-avatar"
                    sx={userDetailStyle.contentContainerGridItem2PaperGridItemItemBox}
                  />
                </Grid>
                <Grid xs={2}>
                  <Typography>Full Name</Typography>
                </Grid>
                <Grid xs={10}>
                  <Typography variant="subtitle1" sx={userDetailStyle.contentTypography}>{userDetail?.fullName}</Typography>
                </Grid>
                <Grid xs={2}>
                  <Typography>Email</Typography>
                </Grid>
                <Grid xs={10}>
                  <Typography variant="subtitle1" sx={userDetailStyle.contentTypography}>{userDetail?.email}</Typography>
                </Grid>
                <Grid xs={2}>
                  <Typography>Person Code</Typography>
                </Grid>
                <Grid xs={10}>
                  <Typography variant="subtitle1" sx={userDetailStyle.contentTypography}>{userDetail?.personCode !== null ? userDetail?.personCode : "-"}</Typography>
                </Grid>
              </Grid>
              <Grid xs={12}>
                <Divider/>
              </Grid>
              <Grid xs={3}>
                <Typography variant="subtitle1" sx={userDetailStyle.contentTypography}>Apps Information</Typography>
              </Grid>
              <Grid container spacing={2} xs>
                <Grid xs={2}>
                  <Typography>Status</Typography>
                </Grid>
                <Grid xs={10}>
                  <Typography variant="subtitle1" sx={userDetailStyle.contentTypography}>{userDetail?.status}</Typography>
                </Grid>
                <Grid xs={2}>
                  <Typography>Role</Typography>
                </Grid>
                <Grid xs={10}>
                  <Typography variant="subtitle1" sx={userDetailStyle.contentTypography}>{userDetail?.role}</Typography>
                </Grid>
              </Grid>
              <Grid xs={12}>
                <Divider/>
              </Grid>
              <Grid xs={3}>
                <Typography variant="subtitle1" sx={userDetailStyle.contentTypography}>Academic Information</Typography>
              </Grid>
              <Grid container spacing={2} xs>
                <Grid xs={2}>
                  <Typography>Institution</Typography>
                </Grid>
                <Grid xs={10}>
                  <Typography variant="subtitle1" sx={userDetailStyle.contentTypography}>{userDetail?.institution !== null ? userDetail?.institution : "-"}</Typography>
                </Grid>
                <Grid xs={2}>
                  <Typography>Faculty</Typography>
                </Grid>
                <Grid xs={10}>
                  <Typography variant="subtitle1" sx={userDetailStyle.contentTypography}>{userDetail?.faculty !== null ? userDetail?.faculty : "-"}</Typography>
                </Grid>
                <Grid xs={2}>
                  <Typography>Study Program</Typography>
                </Grid>
                <Grid xs={10}>
                  <Typography variant="subtitle1" sx={userDetailStyle.contentTypography}>{userDetail?.studyProgram !== null ? userDetail?.studyProgram : "-"}</Typography>
                </Grid>
                <Grid xs={2}>
                  <Typography>Academic Career</Typography>
                </Grid>
                <Grid xs={10}>
                  <Typography variant="subtitle1" sx={userDetailStyle.contentTypography}>{userDetail?.academicCareer !== null ? userDetail?.academicCareer : "-"}</Typography>
                </Grid>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    </Container>
  )
}